import { ActionTypes } from "../contants/Action.Type";
import ApiConnect from "../../Utils/ApiConnect";
import { toast } from "react-toastify";
import jwt from "jsonwebtoken";
import { Redirect, Route } from "react-router";
import React from "react";
import OneSignal from "react-onesignal";

export const AuthSingin =
  (username, password, company, remember) => (dispatch, getstate) => {
    var Loading = true;
    dispatch({ type: ActionTypes.SET_LOADING, payload: Loading });
    var bodyFormData = new FormData();
    bodyFormData.append("username", username);
    bodyFormData.append("password", password);
    bodyFormData.append("company", company);
    bodyFormData.append("remember", remember);
    ApiConnect({
      method: "post",
      url: "/Auth/UserLogin/LoginWithCompany",
      data: bodyFormData,
    })
      .then((response) => {
        if (response.data.status === 200) {
          toast.success(response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          const Token = response.data.token;
          localStorage.setItem("Token", Token);
          localStorage.setItem("MostRecent", JSON.stringify([]));
          dispatch({
            type: ActionTypes.SET_LOGIN_TOKEN,
            payload: { Token: Token, userData: jwt.decode(Token), Auth: true },
          });
          OneSignal.sendTags({
            user: jwt.decode(Token).user_id,
            type: jwt.decode(Token).default,
          });
          dispatch(CompanyInfo());
          window.location.reload();
        } else {
          toast.error(response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }

        dispatch({ type: ActionTypes.SET_LOADING, payload: (Loading = false) });
      })
      .catch((error) => {
        console.log(error);

        dispatch({ type: ActionTypes.SET_LOADING, payload: (Loading = false) });
      });
  };

export const validAuthToken = () => (dispatch, getstate) => {
  var Loading = true;
  dispatch({ type: ActionTypes.SET_LOADING, payload: Loading });
  const token = getstate().Auth.Token || localStorage.Token;
  const UserData = getstate().Auth.userData;
  ApiConnect.get("Auth/UserLogin/UserSession")
    .then((response) => {
      if (response.data.status === 200) {
        localStorage.setItem("Token", token);
        dispatch({
          type: ActionTypes.SET_LOGIN_TOKEN,
          payload: { Token: token, userData: jwt.decode(token), Auth: true },
        });
        OneSignal.sendTags({ user: UserData.user_id, type: UserData.default });
        dispatch(CompanyInfo());
      } else {
        toast.error(response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          draggableDirection: "y",
        });
        dispatch({
          type: ActionTypes.SET_LOGOUT,
          payload: { Token: "", userData: [], Auth: false },
        });
        localStorage.setItem("Token", "");
        return (
          <Route>
            <Redirect to={{ pathname: "/" }} />
          </Route>
        );
      }

      dispatch({ type: ActionTypes.SET_LOADING, payload: (Loading = false) });
    })
    .catch(() => {
      dispatch({ type: ActionTypes.SET_LOADING, payload: (Loading = false) });
    });
};

export const LogoutUser = () => (dispatch) => {
  var Loading = true;
  const TokenData = localStorage.Token;
  dispatch({ type: ActionTypes.SET_LOADING, payload: Loading });
  if (TokenData) {
    localStorage.setItem("Token", "");
    ApiConnect.get(`/Auth/UserLogin/Logout`)
      .then((response) => {
        toast.success(response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          draggableDirection: "y",
        });

        dispatch({
          type: ActionTypes.SET_LOGOUT,
          payload: { Token: "", userData: [], Auth: false },
        });
        dispatch({ type: ActionTypes.SET_LOADING, payload: (Loading = false) });

        window.location.reload();
      })
      .catch(() => {
        dispatch({ type: ActionTypes.SET_LOADING, payload: (Loading = false) });
      });
  } else {
    dispatch({ type: ActionTypes.SET_LOADING, payload: (Loading = false) });
  }
};

export const lockUser = () => (dispatch) => {
  dispatch({ type: ActionTypes.SET_SCREEN_LOCK, payload: true });
};
export const unlockUser = () => (dispatch) => {
  dispatch({ type: ActionTypes.SET_SCREEN_UNLOCK, payload: true });
};
export const CompanyInfo = () => (dispatch, getstate) => {
  const token = getstate().Auth.Token || localStorage.Token;
  const DeToken = jwt.decode(token);
  ApiConnect.get(
    `/Dashboard/UserPermission/CompanyInfo?company=${DeToken["company"]}`
  )
    .then((response) => {
      dispatch({ type: ActionTypes.SET_COMPANY_INFO, payload: response.data });
    })
    .catch((error) => console.log(error));
};
export const LockScreenAuth =
  (username, password, company, remember) => (dispatch, getstate) => {
    var Loading = true;
    dispatch({ type: ActionTypes.SET_LOADING, payload: Loading });
    var bodyFormData = new FormData();
    bodyFormData.append("username", username);
    bodyFormData.append("password", password);
    bodyFormData.append("company", company);
    bodyFormData.append("remember", remember);
    ApiConnect({
      method: "post",
      url: "/Auth/UserLogin/LoginWithCompany",
      data: bodyFormData,
    })
      .then((response) => {
        if (response.data.status === 200) {
          toast.success(response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          const Token = response.data.token;
          localStorage.setItem("Token", Token);
          dispatch({
            type: ActionTypes.SET_SCREEN_AUTH,
            payload: { Token: Token, userData: jwt.decode(Token), Auth: true },
          });
        } else {
          toast.error(response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
        dispatch({ type: ActionTypes.SET_LOADING, payload: (Loading = false) });
      })
      .catch((error) => {
        console.log(error);
      });

    dispatch({ type: ActionTypes.SET_LOADING, payload: (Loading = false) });
  };

export const ChangeUserCompany = (toCompany) => (dispatch) => {
  var Loading = true;
  dispatch({ type: ActionTypes.SET_LOADING, payload: Loading });
  ApiConnect.get(`/Auth/UserLogin/ChangeSession?company=${toCompany}`)
    .then((response) => {
      if (response.data.status === 200) {
        toast.success(response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          draggableDirection: "y",
        });
        const Token = response.data.token;
        localStorage.setItem("Token", Token);
        localStorage.setItem("MostRecent", JSON.stringify([]));
        dispatch({
          type: ActionTypes.SET_LOGIN_TOKEN,
          payload: { Token: Token, userData: jwt.decode(Token), Auth: true },
        });
        OneSignal.sendTags({
          user: jwt.decode(Token).user_id,
          type: jwt.decode(Token).default,
        });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        toast.error(response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          draggableDirection: "y",
        });
      }

      dispatch({
        type: ActionTypes.SET_LOADING,
        payload: (Loading = false),
      });
    })
    .catch((error) => {
      console.log(error);

      dispatch({
        type: ActionTypes.SET_LOADING,
        payload: (Loading = false),
      });
    });
};
